import { createContext, useContext } from 'react';

/**
 * This contains data about the parent measurement project of a datasource, task, etc.
 */
export type MeasurementProjectContextData = {
  isMeasurementProjectActive: boolean;
  measurementProjectId: string;
  // NOTE: named "ForProject" because isApprovalFlowEnabled may apply to FF too
  isApprovalFlowEnabledForProject: boolean;
};

export const MeasurementProjectContext =
  createContext<MeasurementProjectContextData>({
    measurementProjectId: '',
    isMeasurementProjectActive: false,
    isApprovalFlowEnabledForProject: false,
  });

export const useMeasurementProjectContext = () => {
  return useContext(MeasurementProjectContext);
};
